var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"dense":"","solo":"","hide-details":"","disabled":_vm.disabled,"value":_vm.localValue},on:{"change":_vm.changeValue,"input":_vm.changeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }